import type { ReactNode } from 'react';
import { MessageRichWithMeta } from '@/components/Messenger/shared/messages/MessageRichWithMeta';
import { MessageMeta } from '@/components/Messenger/shared/messages/MessageMeta';

export type MessengerPeerBubbleInlineTextAndTimeProps = {
  body: ReactNode;
  bodyClassName?: string;
  timeLabel: string;
  className?: string;
};

/** Входящий peer: тело + время в одной строке (float-мета), единый контур с ЛС/группой. */
export function MessengerPeerBubbleInlineTextAndTime({
  body,
  bodyClassName,
  timeLabel,
  className,
}: MessengerPeerBubbleInlineTextAndTimeProps) {
  return (
    <MessageRichWithMeta
      className={className}
      bodyClassName={bodyClassName}
      body={body}
      meta={
        <MessageMeta
          timeLabel={timeLabel}
          showReadReceipts={false}
          isOwn={false}
          edited={false}
          inline
        />
      }
    />
  );
}
